import { render, staticRenderFns } from "./YagiPostCard.vue?vue&type=template&id=1b5ccae7&scoped=true&"
import script from "./YagiPostCard.vue?vue&type=script&lang=js&"
export * from "./YagiPostCard.vue?vue&type=script&lang=js&"
import style0 from "./YagiPostCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./YagiPostCard.vue?vue&type=style&index=1&id=1b5ccae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ccae7",
  null
  
)

export default component.exports